
"use client";
import React from 'react'
import Reveal from "./Reveal";
import Link from 'next/link';
import { Phone } from "lucide-react";

const FinalCTA = () => {
    return (
        <section className="py-14 md:py-20 bg-[#F8FAFC]">
            <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto text-center">
                <Reveal>
                    <div className="relative bg-linear-to-br from-[#0475B3] to-[#0a3d6b] rounded-md p-12 overflow-hidden">
                        <div className="absolute inset-0">
                            <img src="https://cdn.msu.edu.in/msu-reavamp/phd/bg-img.webp"
                                alt="" className="w-full h-full object-cover opacity-10" />
                        </div>
                        <div className="relative">
                            <div className="inline-flex items-center gap-2 bg-[#FFA201]/20 border border-[#FFA201]/30 rounded-full px-4 py-1.5 mb-6">
                                <span className="w-2 h-2 rounded-full bg-[#FFA201] animate-pulse" />
                                <span className="text-[#FFA201] text-xs font-black uppercase tracking-widest">Limited Seats · 2026 Cohort</span>
                            </div>
                            <h2 className="text-4xl font-black text-white mb-4">Ready to Shape the Future?</h2>
                            <p className="text-blue-200 text-md max-w-lg mx-auto mb-8 leading-relaxed">
                                Join a research ecosystem where knowledge meets real-world impact. Apply today or speak to our Ph.D. counsellors.
                            </p>
                            <div className="flex flex-wrap justify-center gap-4">
                                <Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://application.msu.edu.in/msu-ph-d-application-form"
                                    className="bg-[#FFA201] text-[#081E2D] font-bold px-8 py-3.5 rounded-full text-sm hover:scale-105 hover:shadow-xl hover:shadow-amber-400/30 transition-all duration-200"
                                >
                                    Apply for Ph.D. 2026 →
                                </Link>

                                <Link
                                    href="tel:+919874875876"
                                    className="flex items-center gap-2 border-2 border-white/30 text-white font-bold px-7 py-3.5 rounded-full text-sm hover:bg-white/10 transition-all duration-200"
                                >
                                    <Phone size={18} />
                                    <span>+91 98748 75876</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

export default FinalCTA